import { Route } from '@angular/router';

export const AdminRoutes: Route[] = [
  {
    path: 'admin',
    children: [
      {
        path: '',
        loadComponent: () => import('../pages/admin/admin.page'),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('../pages/admin/admin-detail/admin-detail.page'),
      },
    ],
  },
];
